import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Use environment variables - no fallbacks in production
const finalSupabaseUrl = supabaseUrl;
const finalSupabaseKey = supabaseKey;

// Check for missing credentials
if (!finalSupabaseUrl || !finalSupabaseKey) {
  console.error("Error: Supabase credentials not found. Please check your environment configuration.");
}

export const supabase = createClient(finalSupabaseUrl, finalSupabaseKey); 